import React from 'react';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import './DateRangePickers.css';

interface DateRangePickersProps {
  startDate: Date | null;
  endDate: Date | null;
  onStartDateChange: (date: Date | null) => void;
  onEndDateChange: (date: Date | null) => void;
}

// Max date (current date)
const maxDate = new Date();

export const DateRangePickers: React.FC<DateRangePickersProps> = ({
  startDate,
  endDate,
  onStartDateChange,
  onEndDateChange
}) => {
  return (
    <div className="grid grid-cols-1 sm:grid-cols-2 gap-2 w-full sm:w-auto items-stretch">

      {/* Start Date */}
      <div className="flex flex-col gap-1 w-full sm:w-[200px]">
        <label className="text-xs sm:text-sm font-medium text-[var(--text-secondary)] px-1">
          Start Date
        </label>
        <DatePicker
          selected={startDate}
          onChange={(date: Date | null) => onStartDateChange(date)}
          selectsStart
          startDate={startDate}
          endDate={endDate}
          maxDate={maxDate}
          placeholderText="Start Date"
          className="date-picker-input"
          dateFormat="yyyy/MM/dd"
          wrapperClassName="w-full"
        />
      </div>

      {/* End Date */}
      <div className="flex flex-col gap-1 w-full sm:w-[200px]">
        <label className="text-xs sm:text-sm font-medium text-[var(--text-secondary)] px-1">
          End Date
        </label>
        <DatePicker
          selected={endDate}
          onChange={(date: Date | null) => onEndDateChange(date)}
          selectsEnd
          startDate={startDate}
          endDate={endDate}
          minDate={startDate || undefined}
          maxDate={maxDate}
          placeholderText="End Date"
          className="date-picker-input"
          dateFormat="yyyy/MM/dd"
          wrapperClassName="w-full"
        />
      </div>

    </div>
  );
};
